module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/fineFragrance@3x_ff362e.png";